import axios from "axios"
import { drawId, Token } from "../urlParams"
import { REACT_APP_USER_API_URL } from "../../envVariables";
export interface winnerListProps{
    multiplier:number
    rank:string;
    total_prize_win:number
    username:string
}

export const winnerList=async()=>{
   try{
    const responce=await axios.get(`${REACT_APP_USER_API_URL}lottery/winners-list?drawId=${drawId}`,{
        headers: {
                'Authorization': `AccessToken=${Token}`,
                'Content-Type': 'application/json', 
              }
  })
  return responce.data.data.wonTickets
   }catch(err){
    console.log(err)
   }
}